import http from 'helpers/APIHelper';
import { map } from 'rxjs/operators';
import { compareDates } from 'helpers';

export const IRB_ACTIONS = {
  GET_IRB_APPROVAL_DETAILS: '@regulatory/irb/getIRBApprovalDetails',
  GET_PI_DETAILS: '@regulatory/irb/getPIDetails'
};

export const getIRBApprovalDetails = (token, loggerInfo, data) => {
  const filter = [];
  Object.keys(data).forEach(key => filter.push({ field: key, operation: 'contains', value: data[key] }));

  return http.postWithToken(`regulatory-data-service/v1/irb/approvaldetails`, token, data, loggerInfo);
};

export const getIRBApprovalDetailsByID = (token, loggerInfo, irbID, data) => http.postWithToken(`regulatory-data-service/v1/irb/approvaldetails/id/${irbID}`, token, data, loggerInfo);

export const getIRBIDList = (token, loggerInfo, sourceContext, data) => http.postWithToken(`regulatory-data-service/v1/irb/context/${sourceContext}/irbIdList`, token, data, loggerInfo);

export const getIRBname = (token, loggerInfo, irbnum) => http
  .getWithToken(`regulatory-data-service/v1/irb/number/${irbnum}`, token, loggerInfo)
  .pipe(map((resp) => resp.response));

export const saveIRBApprovalDetails = (token, loggerInfo, data) => http
  .putWithToken(`regulatory-data-service/v1/irb/approvaldetails`, token, data, loggerInfo)
  .pipe(map((resp) => resp.response));

export const saveIrbPiDetails = (token, loggerInfo, irbId, data) => http
  .putWithToken(`regulatory-data-service/v1/irb/id/${irbId}/pi/details`, token, data, loggerInfo)
  .pipe(map((resp) => resp.response));

export const validateIrbPiDetails = (token, loggerInfo, data) => http
  .postWithToken(`regulatory-data-service/v1/irb/pi/validation`, token, data, loggerInfo)
  .pipe(map((resp) => resp.response));

export const updateChangePI = (token, loggerInfo, irbId) => http
  .putWithToken(`regulatory-data-service/v1/irb/id/${irbId}/pi/latest`, token, {}, loggerInfo)
  .pipe(map((resp) => resp.response));

export const getPIGridDetails = (token, loggerInfo, irbId) => (dispatch) => http.getWithToken(`regulatory-data-service/v1/irb/id/${irbId}/pi/details`, token, loggerInfo).subscribe((resp) => {
  if (resp.response != null && resp.response.length > 0) {
    resp.response.sort((a, b) => {
      const { startDate: startDateA, endDate: endDateA } = a;
      const { startDate: startDateB, endDate: endDateB } = b;
      if ((endDateA == null && endDateB == null) || (endDateA != null && endDateB != null)) {
        return compareDates(startDateA, startDateB);
      }
      return endDateB == null ? 1 : -1;
    });
  }
  dispatch({
    type: IRB_ACTIONS.GET_PI_DETAILS,
    payload: resp.response
  });
});

export const getPersonRegistrationAutoCompleteApi = (token, loggerInfo, postBody) => () => http.postWithToken(`person-data-service/v1/persons/autocomplete/criteria`, token, postBody, loggerInfo);

export const getPiRegistrationTypeApi = (token, loggerInfo, protocolNumber) => http.getWithToken(`protocol-data-service/v1/protocols/number/${protocolNumber}/task/Site%20Protocol%20PI/regtype`, token, loggerInfo, {}, 'text');

export const getSignCtepID = (token, loggerInfo, ctepId, signId) => http
  .getWithToken(`site-data-service/v1/sites/id/${ctepId}/autocomplete/${signId}`, token, loggerInfo)
  .pipe(map((resp) => resp));

export const getPIPacketIds = (token, loggerInfo, packetIdLike, extraFilters = {}) => {
  const extFilters = Object.keys(extraFilters).map((k) => ({
    field: k,
    operation: 'contains',
    value: extraFilters[k]
  }));
  const data = {
    filter: [{ field: 'packetId', operation: 'contains', value: packetIdLike }, ...extFilters]
  };
  return http.postWithToken(`regulatory-data-service/v1/packets/browse`, token, data, loggerInfo);
};

export const getProtocolStatus = (token, loggerInfo, protocolNumber) => http
  .getWithToken(
    `protocol-data-service/v1/protocols/details/autocomplete/protocol/${protocolNumber}`,
    token,
    loggerInfo
  )
  .pipe(
    map((resp) => {
      if (resp.response != null && Array.isArray(resp.response)) {
        const row = resp.response.find((r) => r.protocolNumber === protocolNumber);
        return row.status;
      }
      return null;
    })
  );

export const getProtocol = (token, loggerInfo, protocolNumber) => http
  .getWithToken(
    `protocol-data-service/v1/protocols/details/autocomplete/protocol/${protocolNumber}`,
    token,
    loggerInfo
  )
  .pipe(map((resp) => resp));

export const callQAChecks = (token, loggerInfo, data) => http
  .postWithToken(`regulatory-data-service/v1/irb/qachecks`, token, data, loggerInfo, 'text')
  .pipe(map((resp) => resp.response));

export const validateInstutionCtepId = (token, loggerInfo, sigSiteCtepId) => http
  .getWithToken(`irost-data-service/v1/sites/number/${sigSiteCtepId}/status/Y/tree`, token, loggerInfo)
  .pipe(map((resp) => resp.response));

export const deleteIrbApproval = (token, loggerInfo, id) => http.deleteWithToken(`regulatory-data-service/v1/irb/approvaldetails/id/${id}`, token, loggerInfo);

export const getIRBModificationHistory = (token, loggerInfo, irbCertificationId) => () => http.getWithToken(
  `regulatory-data-service/v1/irb/approvaldetails/id/${irbCertificationId}/audits`,
  token,
  loggerInfo
);

export const getExpiryDate = (token, loggerInfo, data, approvalType) => http.postWithToken(`regulatory-data-service/v1/irb/approvaltype/${approvalType}/expirydate`, token, data, loggerInfo);
